module.exports = __webpack_public_path__ + "static/media/governmentsarjah.945be63f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/governmentsarjah.png
// module id = 54
// module chunks = 0